import { render, staticRenderFns } from "./screenAdapter.vue?vue&type=template&id=8821b01c&scoped=true"
import script from "./screenAdapter.vue?vue&type=script&lang=js"
export * from "./screenAdapter.vue?vue&type=script&lang=js"
import style0 from "./screenAdapter.vue?vue&type=style&index=0&id=8821b01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8821b01c",
  null
  
)

export default component.exports